import React from 'react';
import { notification } from "antd";
import { CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import trans from './translation';
import $ from 'jquery';

export class Base {

    /**
     * 获取当前相对路径
     */
    static getUrlRelativePath() {
        var url = document.location.toString();
        var arrUrl = url.split("//");

        var start = arrUrl[1].indexOf("/");
        var relUrl = arrUrl[1].substring(start);

        if (relUrl.indexOf("?") !== -1) {
            relUrl = relUrl.split("?")[0];
        }
        return relUrl;
    }

    /**
     * 传入秒数,将其转换成
     */
    static timeLongConversion(timeLong) {
        if (typeof timeLong !== 'number') {
            return null;
        } else {
            let str = '';
            let h = parseInt(timeLong / (60 * 60));
            if (h > 0) { str += h + '时'; }
            let m = parseInt(timeLong % (60 * 60) / 60);
            if (m > 0) { str += m + '分'; }
            let s = parseInt(timeLong % (60 * 60) % 60);
            if (s > 0) { str += s + '秒'; }
            return str;
        }
    }


    /**
  * 时间格式化处理
  * @param date 要處理的時間
  * @param fmt 要轉換的格式
  */
    static dateFormat(date, fmt = "dd/MM/yyyy") { //author: meizz
        if (date == null) {
            return;
        }
        date = new Date(date);
        var o = {
            "M+": date.getMonth() + 1,                 //月份   
            "d+": date.getDate(),                    //日   
            "h+": date.getHours(),                   //小时   
            "m+": date.getMinutes(),                 //分   
            "s+": date.getSeconds(),                 //秒   
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
            "S": date.getMilliseconds()             //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    /**
     * @description : 校验身份证号是否合规（18位、15位）
     * @param        {String|Number} value
     * @return       {Boolean} true-合规 false-不合规
     */
    static checkIdCardNo(value) {
        let psidno = String(value)
        // 1.校验身份证号格式和长度
        let regPsidno = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/
        if (!regPsidno.test(psidno)) {
            return false
        }
        // 2.校验前两位的省份编码是否正确
        let province = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
        if (!province[Number(psidno.slice(0, 2))]) {
            return false
        }
        // 3.校验出生日期
        if (psidno.length === 15) {
            // 15位号码 省（2位）市（2位）县（2位）年（2位）月（2位）日（2位）校验码（3位）
            let reg = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
            let arrSplit = psidno.match(reg)
            // 15位号码在年份前补 19 或 20
            let year = Number(arrSplit[2].charAt(0)) > 0 ? '19' + arrSplit[2] : '20' + arrSplit[2]
            let month = arrSplit[3]
            let day = arrSplit[4]
            if (!validateBirthday(year, month, day)) {
                return false
            }
        } else if (psidno.length === 18) {
            // 18位号码 省（2位）市（2位）县（2位）年（4位）月（2位）日（2位）校验码（4位）
            let reg = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
            let arrSplit = psidno.match(reg)
            let year = arrSplit[2]
            let month = arrSplit[3]
            let day = arrSplit[4]
            if (!validateBirthday(year, month, day)) {
                return false
            }
        } else {
            return false
        }
        // 校验出生日期是否合理
        function validateBirthday(year, month, day) {
            year = Number(year) // 年
            month = Number(month) // 月
            day = Number(day) // 日
            let nowTime = new Date().getTime() // 当前时间戳
            let birthTime = new Date(`${year}-${month}-${day}`).getTime() // 获取出生日期的时间戳
            // 不能是明天出生的吧
            if (birthTime > nowTime) {
                return false
            }
            // 一般人活不到150岁吧
            let nowYear = new Date().getFullYear()
            if ((nowYear - year) > 150) {
                return false
            }
            // 不能是13月出生的吧
            if (month < 1 || month > 12) {
                return false
            }
            // 不能是2月30号、4月31号、5月32号出生的吧
            let date = new Date(year, month, 0) // 获取当月的最后一天
            if (day < 1 || day > date.getDate()) {
                return false
            }
            return true
        }
        // 4.18位号码校验生成的校验码
        if (psidno.length === 18) {
            let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 加权因子
            let parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码
            let sum = 0
            for (let i = 0; i < 17; i++) {
                sum += Number(psidno.charAt(i)) * Wi[i]
            }
            if (parity[sum % 11] !== psidno[17]) {
                return false
            }
        }
        return true
    }

    /**
     * 提示信息框
     * type表示类型 正常提示:success 警告:warning 错误:error
     * content表示提示信息,多条信息
     */
    static alertMessage = (type, content) => {
        // message.config({top: 100,duration: 3,maxCount: 1});
        let arr = content === null ? [] : content.split(';');
        let msgList = [];
        let msgType = '';
        let color = '';
        let iconType = '';
        if (arr.length > 0) {
            let index = 1;
            content = '';
            for (let i in arr) {
                if (arr[i].trim() !== '') {
                    msgList.push(<div style={{ paddingTop: '5px' }} key={index}>{index++ + '.' + arr[i]}</div>)
                }
            }
        }
        switch (type) {
            case 'success': msgType = '提示'; color = 'green'; iconType = <CheckCircleOutlined />; break;
            case 'warning': msgType = '警告'; iconType = <ExclamationCircleOutlined />; break;
            case 'error': msgType = '错误'; color = 'red'; iconType = <CloseCircleOutlined />; break;
        }

        notification.open({
            key: 1,
            message: <div style={{ color: color }}>{msgType}</div>,
            description: msgList,
            icon: iconType,
            style: {
                color: color
            },
            duration: 3
        });
    };

    /**
     * 根据传入的一级菜单的url地址查找到对应下级菜单的所有信息
     * @param {String} name 
     */
    static getFunc(url) {
        let menuList = window.backMenu;
        menuList = Base.sysFuncCombination(menuList);
        let func = [];
        if (menuList != null) {
            for (let i in menuList) {
                if (menuList[i].url === url) {
                    func = menuList[i].menu2List;
                    break;
                }
            }
        }
        return func;
    }

    /**
     * 对模块进行分类
     * @param {Array} data 
     */
    static sysFuncCombination(data) {
        let list = [];
        let menu = {};
        let func = {};
        for (let i in data) {
            if (data[i].type === 'menu') {
                menu = {};
                menu.name = data[i].funcName;
                menu.url = data[i].uiSref;
                menu.menu2List = [];
                for (let j in data) {
                    if (data[j].type === 'func' && data[i].sysFuncId === data[j].parentId) {
                        func = {};
                        func.name = data[j].funcName;
                        func.url = data[j].uiSref;
                        func.component = Base.transform(data[j].funcFileUrl);
                        menu.menu2List.push(func);
                    }
                }
                list.push(menu);
            }
        }
        return list;
    }

    /**
     * 校验参数是否为空
     * String 类型校验，当值为（null,undefined,'','  '）时都为空返回true
     * Array 类型校验，当值为（null,undefined,Array.length === 0）时都为空返回true
     * @param {*} param 要校验的参数  
     */
    static isEmpty(param) {
        if (param == null) {
            return true;
        }
        let flag = false;
        // 基本类型判断（还可以判断 number,boolean 类型）
        if (typeof param === "string") {
            if (param.trim() === '') {
                flag = true;
            }
        }// 对象类型判断（还可以判断 Object，Function 类型）
        else if (param instanceof Array) {
            if (param.length === 0) {
                flag = true;
            }
        }
        return flag;
    }

    /**
     * 校验参数是否不为空，跟isEmpty方法相反
     * @param {*} param 要校验的参数  
     */
    static isNotEmpty(param) {
        return !Base.isEmpty(param);
    }

    static stopClickFirstTime = 0;//记录用户上一次点击的时间
    /**防止重复点击 */
    static stopClick(time = 3000) {
        let secondTime = new Date().getTime();
        if (secondTime - Base.stopClickFirstTime > time) {
            Base.stopClickFirstTime = secondTime;
            return true;
        }
        return false;
    }

    /**
     * 选中或取消选中当前行
     * @param {*} record 当前点击行记录
     * @param {string} rowKey 当前table的主键 
     * @param {string} rows 选中记录集合名
     * @param {string} rowKeys 选中记录key集合名
     */
    static selectRow = function (record, rowKey, rows, rowKeys) {
        let selectedRowKeys = [...this.state[rowKeys]];
        let checkboxState = [...this.state[rows]];
        if (selectedRowKeys.indexOf(record[rowKey]) >= 0) {
            //当点击选中的数据，取消选中
            selectedRowKeys.splice(selectedRowKeys.indexOf(record[rowKey]), 1);
            checkboxState.splice(checkboxState.findIndex(item => item[rowKey] == record[rowKey]), 1);
        } else {
            //选中的数据放入数组
            selectedRowKeys.push(record[rowKey]);
            checkboxState.push(record);
        }
        this.setState({ [rowKeys]: selectedRowKeys, [rows]: checkboxState });
    }

    /**
     * 选中或取消选中当前行，处理radio选中
     * @param {*} record 当前点击行记录
     * @param {String} rowKey 当前table的主键 
     * @param {String} rows 选中记录集合名
     * @param {String} rowKeys 选中记录key集合名
     * @param {Boolean} flag 不清空選中
     * @param {Function} method
     */
    static selectRadioRow = function (record, rowKey, rows, rowKeys, flag, method) {
        let selectedRowKeys = [...this.state[rowKeys]];
        let checkboxState = [...this.state[rows]];
        if (!flag && selectedRowKeys.indexOf(record[rowKey]) > -1) {
            selectedRowKeys = [];
            checkboxState = [];
        } else {
            selectedRowKeys = [record[rowKey]];
            checkboxState = [record];
        }
        let that = this;
        that.setState({ [rowKeys]: selectedRowKeys, [rows]: checkboxState }, function () {
            if (method != null) {
                method.call(that);
            }
        });
    }

    /**
     * 选中或取消选中当前行
     * @param {*} record 当前点击行记录
     * @param {string} rowKey 当前table的主键 
     * @param {Array} rows 选中记录集合
     * @param {Array} rowKeys 选中记录key集合
     * @param {Function} setRows 設置选中记录key集合方法
     * @param {Function} setRowKeys 設置选中记录key集合方法
     */
    static selectRowNew = function (record, rowKey, rows, rowKeys, setRows, setRowKeys) {
        let selectedRowKeys = [...rowKeys];
        let checkboxState = [...rows];
        if (selectedRowKeys.indexOf(record[rowKey]) >= 0) {
            //当点击选中的数据，取消选中
            selectedRowKeys.splice(selectedRowKeys.indexOf(record[rowKey]), 1);
            checkboxState.splice(checkboxState.findIndex(item => item[rowKey] == record[rowKey]), 1);
        } else {
            //选中的数据放入数组
            selectedRowKeys.push(record[rowKey]);
            checkboxState.push(record);
        }
        setRows(checkboxState);
        setRowKeys(selectedRowKeys);
    }

    /**
     * 选中或取消选中当前行，处理radio选中
     * @param {*} record 当前点击行记录
     * @param {String} rowKey 当前table的主键 
     * @param {Array} rowKeys 选中记录key集合
     * @param {Function} setRows 設置选中记录key集合方法
     * @param {Function} setRowKeys 設置选中记录key集合方法
     * @param {Boolean} flag 不清空選中
     * @param {Function} method
     */
    static selectRadioRowNew = function (record, rowKey, rowKeys, setRows, setRowKeys, flag, method) {
        if (!flag && rowKeys.find(item => item == record[rowKey])) {
            setRows([]);
            setRowKeys([]);
        } else {
            setRows([record]);
            setRowKeys([record[rowKey]]);
        }
        if (method != null) {
            method.call(this);
        }
    }

    /**
     * 数字千分位格式化
     * @param {number} number 
     */
    static numberFormat(number, len) {
        if (Base.isEmpty(number)) {
            return "";
        }
        if (Object.is(parseFloat(number), NaN)) {//如果不是数字
            return number;
        }
        if (Base.isNotEmpty(len) && Object.is(parseFloat(len), NaN)) {//如果不是数字
            return number;
        }
        if (Base.isNotEmpty(len)) {
            if (len > 3) {
                /**小數大於三位時，不對小數進行千分位格式化*/
                let str = number.toString()
                let decimalStr = str.lastIndexOf(".") > -1 ? 0 + str.slice(str.lastIndexOf("."), str.length) : "0";
                let rounding = parseFloat(decimalStr).toFixed(len)
                let decimal = rounding.slice(rounding.indexOf("."), rounding.length)
                let integer = str.lastIndexOf(".") > -1 ? str.slice(0, str.lastIndexOf(".")) : str
                let formatNumber = `${parseFloat(integer)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + decimal
                return formatNumber;
            }
            return `${parseFloat(number).toFixed(len)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
            return `${parseFloat(number)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }

    /**
     * 校驗date1是否大於date2，只判断年月日
     * @param {*} date1 
     * @param {*} date2 
     */
    static afterDate(date1, date2) {
        let result = false;
        if (!date1 || !date2) {
            return;
        }
        date1 = new Date(date1);
        date2 = new Date(date2);
        if (date1.getFullYear() > date2.getFullYear()) {
            result = true;
        } else if (date1.getFullYear() === date2.getFullYear()) {
            if (date1.getMonth() > date2.getMonth()) {
                result = true;
            } else if (date1.getMonth() === date2.getMonth()) {
                if (date1.getDate() > date2.getDate()) {
                    result = true;
                }
            }
        }
        return result;
    }

    /**
     * 校驗date1是否大於date2，年月日时分
     * @param {*} date1 
     * @param {*} date2 
     */
    static afterDateTime(date1, date2) {
        let result = false;
        if (!date1 || !date2) {
            return;
        }
        date1 = new Date(date1);
        date2 = new Date(date2);
        if (date1.getFullYear() > date2.getFullYear()) {
            result = true;
        } else if (date1.getFullYear() === date2.getFullYear()) {
            if (date1.getMonth() > date2.getMonth()) {
                result = true;
            } else if (date1.getMonth() === date2.getMonth()) {
                if (date1.getDate() > date2.getDate()) {
                    result = true;
                } else if (date1.getDate() === date2.getDate()) {
                    if (date1.getHours() > date2.getHours()) {
                        result = true;
                    } else if (date1.getHours() === date2.getHours()) {
                        if (date1.getMinutes() > date2.getMinutes()) {
                            result = true;
                        } else if (date1.getMinutes() === date2.getMinutes()) {
                            if (date1.getSeconds() >= date2.getSeconds()) {
                                result = true;
                            }
                        }
                    }
                }
            }
        }
        return result;
    }

    /**
     * 校驗date1是否大於等於date2，只判断年月日
     * @param {*} date1 
     * @param {*} date2 
     */
    static afterEqDate(date1, date2) {
        let result = false;
        if (!date1 || !date2) {
            return;
        }
        date1 = new Date(date1);
        date2 = new Date(date2);
        if (date1.getFullYear() > date2.getFullYear()) {
            result = true;
        } else if (date1.getFullYear() === date2.getFullYear()) {
            if (date1.getMonth() > date2.getMonth()) {
                result = true;
            } else if (date1.getMonth() === date2.getMonth()) {
                if (date1.getDate() > date2.getDate()) {
                    result = true;
                } else if (date1.getDate() === date2.getDate()) {
                    result = true;
                }
            }
        }
        return result;
    }

    /**
     * 校驗數字不能小於0(可以為空)
     * @param {*} value 當前值 
     * @param {*} callback 組件方法
     */
    static checkNbrZero = (value) => {
        if (Base.isNotEmpty(value) && value <= 0) {
            return Promise.reject(trans.greaterThan0[Config.backLang]);
        } else {
            return Promise.resolve();
        }
    };

    /**
     * 校驗數字不能小於0且不能為空
     * @param {*} value 當前值 
     * @param {*} callback 組件方法
     */
    static checkNbrZeroOrNull = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.numISNotNull[Config.backLang]);
        } else if (value <= 0) {
            return Promise.reject(trans.greaterThan0[Config.backLang]);
        } else {
            return Promise.resolve();
        }
    };

    /**
     * 校驗數字不能大於或小於指定參數值
     * @param {*} value 當前值 
     * @param {*} min 最小值
     * @param {*} max 最大值
     */
    static checkNbr = (value, min, max) => {
        if (Base.isNotEmpty(value)) {
            if (max != null && value > max) {
                return Promise.reject(trans.greaterThan[Config.backLang] + max);
            } else if (min != null && value < min) {
                return Promise.reject(trans.lessThan[Config.backLang] + min);
            } else if (min == null && value <= 0) {//min == null 默認賦值為0
                return Promise.reject(trans.greaterThan0[Config.backLang]);
            }
        }
        return Promise.resolve();
    };

    /**
     * 校驗數字不能為空，並且不能大於或小於指定參數值min, max
     * @param {*} value 當前值 
     * @param {*} min 最小值
     * @param {*} max 最大值
     */
    static checkNbrOrNull = (value, min, max) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.numISNotNull[Config.backLang]);
        } else {
            if (max != null && value > max) {
                return Promise.reject(trans.greaterThan[Config.backLang] + max);
            } else if (min != null && value < min) {
                return Promise.reject(trans.lessThan[Config.backLang] + min);
            } else if (min == null && value <= 0) {//min == null 默認賦值為0
                return Promise.reject(trans.greaterThan0[Config.backLang]);
            } else {
                return Promise.resolve();
            }
        }
    };

    /**
   * 效验数字不能为空，并且不能大于或小于指定参数min max和数值大于等于0
   * @param {*} value 當前值 
   * @param {*} min 最小值
   * @param {*} max 最大值
   */
    static checkNbrOrNumber = (value, min, max) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.numISNotNull[Config.backLang]);
        } else {
            if (max != null && value > max) {
                return Promise.reject(trans.greaterThan[Config.backLang] + max);
            } else if (min != null && value < min) {
                return Promise.reject(trans.lessThan[Config.backLang] + min);
            } else if (min == null && value < 0) {//min == null 默認賦值為0
                return Promise.reject(trans.greaterThan0[Config.backLang]);
            } else {
                return Promise.resolve();
            }
        }
    };

    /**
     * 排序方法
     * @param {*} a 
     * @param {*} b 
     * @param {*} name 栏位名
     */
    static sortMethod(a, b, name) {
        if (a[name] == null && b[name] != null) {
            return -1;
        } else if (a[name] != null && b[name] == null) {
            return 1;
        } else if (a[name] != null && b[name] != null) {
            var stringA = a[name];
            var stringB = b[name];
            if (a[name].constructor === String || b[name].constructor === String) {
                stringA = stringA.toUpperCase(); // ignore upper and lowercase
                stringB = stringB.toUpperCase();
            }
            if (stringA < stringB) {
                return -1;
            }
            if (stringA > stringB) {
                return 1;
            }
        }
        return 0;
    }

    /**
     * 获取设备类型(iPad/phone/pc)
     */
    static getEquipmentType = function () {
        let type;
        if (navigator.userAgent.indexOf('iPad') !== -1) {
            type = 'iPad';
        } else if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            type = 'phone';
        } else {
            type = 'pc';
        }
        return type;
    };
    /**访问设备 true:手机端 false:pc端**/
    static cgIsEnd = function () {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            return true;
        } else {
            return false;
        }
    };
    /**判断手机    android:安卓FF    iPhone:苹果    0:都不是   返回类型String**/
    static cgIsPhone = function () {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Windows Phone)/i))) {
            return "iPhone";
        } else if ((navigator.userAgent.match(/(Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian)/i))) {
            return "android";
        } else {
            return "0"
        }
    };
    /**判断微信浏览器访问    true:是    false:否*/
    static cgIsWeixn = function () {
        var ua = navigator.userAgent?.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    };
    /**判断打开浏览器*/
    static cgIsView = function () {
        var userAgent = navigator.userAgent;
        return userAgent.split(" ");
    };

    /**
     * 调用后台api
     * @param {String} url api url
     * @param {*} param 传参
     * @returns api结果
     */
    static callBackApi = async function (url, param) {
        if (Base.isEmpty(Config.header.authorization)) {
            Config.header.authorization = localStorage.getItem('wilBackAccessToken');
        }
        const res = await fetch(Config.apiBackServer + url, {
            method: 'POST',
            body: param ? JSON.stringify(param) : null,
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        });
        let result = await res.json();
        if (result.errorCode === "OVERTIME") {
            Base.removeAllLocalStorage();
            window.location.href = Config.sysUrl + "#/login";
        } else {
            if (result.errorCode === "TOKEN_EXPIRED") {
                let token = localStorage.getItem('wilBackRefreshToken');
                if (token) {
                    fetch(Config.apiServer + "admin/login/refreshToken", {
                        method: 'POST',
                        body: JSON.stringify(token),
                        headers: Config.header,
                        mode: 'cors',
                        cache: 'default'
                    }).then(res => res.json()).then((data) => {
                        if ("SUCCESS" === data.msg) {
                            Config.header.authorization = data.object.accessToken + '';
                            localStorage.setItem('wilBackAccessToken', data.object.accessToken);
                            localStorage.setItem('wilBackRefreshToken', data.object.refreshToken);
                        } else {
                            Base.removeAllLocalStorage();
                            window.location.href = Config.sysUrl + "#/login";
                        }
                    }).catch(err => { });
                } else {
                    Base.removeAllLocalStorage();
                    window.location.href = Config.sysUrl + "#/login";
                    return;
                }
            }
            return result;
        }
    }

    /**
     * 调用后台api
     * @param {String} url api url
     * @param {*} param 传参
     * @returns api结果
     */
    static callBackUploadApi = async function (url, formData) {
        if (Base.isEmpty(Config.header.authorization)) {
            Config.header.authorization = localStorage.getItem('wilBackAccessToken');
        }
        const res = await fetch(Config.apiBackServer + url, {
            method: 'POST',
            body: formData,
            headers: { 'authorization': Config.header.authorization, 'x-auth-token': Config.header['x-auth-token'], 'func': Config.header.func },
            mode: 'cors',
            cache: 'default'
        });
        let result = await res.json();
        if (result.errorCode === "OVERTIME") {
            Base.removeAllLocalStorage();
            window.location.href = Config.sysUrl + "#/login";
        } else {
            if (result.errorCode === "TOKEN_EXPIRED") {
                let token = localStorage.getItem('wilBackRefreshToken');
                if (token) {
                    fetch(Config.apiServer + "admin/login/refreshToken", {
                        method: 'POST',
                        body: JSON.stringify(token),
                        headers: Config.header,
                        mode: 'cors',
                        cache: 'default'
                    }).then(res => res.json()).then((data) => {
                        if ("SUCCESS" === data.msg) {
                            Config.header.authorization = data.object.accessToken + '';
                            localStorage.setItem('wilBackAccessToken', data.object.accessToken);
                            localStorage.setItem('wilBackRefreshToken', data.object.refreshToken);
                        } else {
                            Base.removeAllLocalStorage();
                            window.location.href = Config.sysUrl + "#/login";
                        }
                    }).catch(err => { });
                } else {
                    Base.removeAllLocalStorage();
                    window.location.href = Config.sysUrl + "#/login";
                    return;
                }
            }
            return result;
        }
    }

    /**
     * 清除缓存
     */
    static removeAllLocalStorage = () => {
        localStorage.removeItem('wilBackAccessToken');
        localStorage.removeItem('wilBackRefreshToken');
        localStorage.removeItem("menuList");
        localStorage.removeItem("openKeys");
        localStorage.removeItem("wilBackLang");
    }

    /**
     * code转大写
     * @param {String} e 值
     * @param {number} length 最大长度
     * @returns 大写code
     */
    static codeChange = function (e, length) {
        let value = e.target.value;
        if (value.length <= length) {
            //1.禁止两边输入空格 2.只能输入字母、-、_ 3.输入变大写
            value = value.replace(/^ +| +$/g, '').replace(/[^\w_\-*]/ig, '').toLocaleUpperCase();
        }
        return value;
    }

    /**
     * 比较两个对象内容是否相同（无递归）
     * @param {*} a 对象
     * @param {*} b 对象
     * @returns 结果
     */
    static isObjectValueEqual = function (a, b) {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);

        if (aProps.length != bProps.length) {
            return false;
        }

        aProps.forEach(propName => {
            var propA = a[propName];
            var propB = b[propName];
            if (propA !== propB) {
                return false;
            }
        });
        return true;
    }

    /**
     * 下载文件
     * @param {String} urlPath 文件url
     */
    static downloadFile = async function (urlPath, fileName) {
        const response = await fetch(urlPath);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    /**
     * 判断对象是否没有属性
     * @param {obj} obj 
     * @returns 
     */
    static isEmptyObject = (obj) => {
        return Object.keys(obj).length === 0;
    }

     /**
     * 格式化小数位 toFixed()为四舍五入
     * @param {*} text 
     * @param {*} fixed 
     * @returns 
     */
     static parseToFixed = (text, fixed) => {
        let value = parseFloat(text);
        return isNaN(value) ? '' : value.toFixed(fixed);
    }
        
    /**
     * 格式化百分比
     * @param {*} text 
     * @returns 
     */
    static parseToPercent = (text) => {
        let value = parseFloat(text);
        return isNaN(value) ? 0 : Math.floor(text * 10000) / 100;
    }
    
    /**
     * 计算等级
     * @param {*} score 
     * @returns 
     */
    static calcGrade(score) {
        if (score >= 85) {
            return 'A';
        } else if (score >= 80) {
            return 'A-';
        } else if (score >= 75) {
            return 'B+';
        } else if (score >= 70) {
            return 'B';
        } else if (score >= 65) {
            return 'B-';
        } else if (score >= 60) {
            return 'C+';
        } else if (score >= 55) {
            return 'C';
        } else if (score >= 50) {
            return 'C-';
        } else if (score >= 45) {
            return 'D+';
        } else if (score >= 40) {
            return 'D';
        } else {
            return 'F';
        }
    }   

    /**
     * 生成导出文件随机数后缀
     * @returns 随机数后缀
     */
    static generateFourDigitRandomNumber = () => {
        const min = 1000; // 最小值（包含）
        const max = 9999; // 最大值（包含）
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }

    /**
     * 数字替换
     * @param {*} number 
     * @param {*} replaceSymbol 
     * @returns 
     */
    static numberReplaceSymbol = (number, replaceSymbol) => {
        if (number === undefined || number === null || number === "") {
          return replaceSymbol;
        } else {
          return number;
        }
    }
}